import { MetadataTypeId, MetadataValueType } from '@/types/analytics/analytics.types';
import { i18n_t as $t } from '@/utils/i18n';

type UtmParameters = 'source' | 'medium' | 'campaign' | 'term' | 'content';
type AutomaticGroups = 'channel' | 'referrer';

interface WebAnalyticsMapItem {
    DisplayName: string;
    field: UtmParameters | AutomaticGroups;
}

export const UTM_PARAMETERS = (): WebAnalyticsMapItem[] => [
    { DisplayName: $t('utmParameters.Source'), field: 'source' },
    { DisplayName: $t('utmParameters.Campaign'), field: 'campaign' },
    { DisplayName: $t('utmParameters.Medium'), field: 'medium' },
    { DisplayName: $t('utmParameters.Term'), field: 'term' },
    { DisplayName: $t('utmParameters.Content'), field: 'content' },
];

export const AUTOMATIC_GROUP_PARAMETERS = (): WebAnalyticsMapItem[] => [
    { DisplayName: $t('utmParameters.Channel'), field: 'channel' },
    { DisplayName: $t('utmParameters.Referrer'), field: 'referrer' },
];

export const getSessionPropertyNames = () => [...UTM_PARAMETERS(), ...AUTOMATIC_GROUP_PARAMETERS()].map(
    (item) => item.DisplayName,
);

export const getUtmParameterNames = () => UTM_PARAMETERS().map((item) => item.DisplayName);

export const getAutomaticGroupNames = () => AUTOMATIC_GROUP_PARAMETERS().map((item) => item.DisplayName);

function mapParameters (item: WebAnalyticsMapItem) {
    return {
        ...item,
        sortable: true,
        kind: MetadataTypeId.Utm as MetadataTypeId.Utm,
        label: item.DisplayName,
        prop: `__utm__.${item.field}`,
        Type: 'string' as MetadataValueType,
        ElementType: 'string' as MetadataValueType,
        isUtm: true,
    };
}

export function getUtmParametersArr () {
    return UTM_PARAMETERS().map(mapParameters);
}

export function getAutomaticGroupsParametersArr () {
    return AUTOMATIC_GROUP_PARAMETERS().map(mapParameters);
}

export function getAllUtmRelatedParameters () {
    const allParameters = [...UTM_PARAMETERS(), ...AUTOMATIC_GROUP_PARAMETERS()];

    return allParameters.map(mapParameters);
}
